<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-3">
        <div class="side-heading">
          <h6>{{ $t('fainancialView.financialReports') }}</h6>
          <p class="font13 gray-col mb-0">
            {{ $t('fainancialView.subtitle') }}
          </p>
        </div>
        <div class="calenders">
          <div class="calender-from">
            <div>{{ $t('fainancialView.from') }}</div>
            <div class="calender-from-main">
              <Calendar v-model="dateBegin" :placeholder="$t('fainancialView.selectDate')" dateFormat="dd/mm/yy" :maxDate="new Date()"
                @date-select="resetDateEnd" />
              <div class="abs-calender">
                <i class="fa-regular fa-calendar"></i>
              </div>
            </div>
          </div>
          <div class="calender-from">
            <div>{{ $t('fainancialView.to') }}</div>
            <div class="calender-from-main">
              <Calendar v-model="dateEnd" :disabled="!dateBegin" :placeholder="$t('fainancialView.selectDate')" dateFormat="dd/mm/yy"
                :minDate="dateBegin" @date-select="filterFainancial" />
              <div class="abs-calender">
                <i class="fa-regular fa-calendar"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <chartView :total_profits="total_profits" orange="true" />
      <div class="mb-4"></div>
      <dataTable :tableData="financials" :showLink="false" :HeadOfTable="HeadOfTable"
        linkDirection="MaintenanceDetails" />
    </div>
  </main>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";
import chartView from "../components/dashboard/chartView.vue";
import dataTable from "../components/dashboard/dataTable.vue";
import Calendar from "primevue/calendar";
import axios from "axios";
import { useI18n } from "vue-i18n";
import moment from "moment";

import { ref, onMounted } from "vue";
const { t } = useI18n();

// reactive state
const total_profits = ref("");
const dateBegin = ref(null);
const dateEnd = ref(null);
const HeadOfTable = ref([
  {
    headText: t('fainancialView.serialNumber'),
    headKey: "id",
  },
  {
    headText: t('fainancialView.buildingCode'),
    headKey: "building_code",
  },
  {
    headText: t('fainancialView.buildingName'),
    headKey: "building_name",
  },
  {
    headText: t('fainancialView.ownerName'),
    headKey: "owner_name",
  },
  {
    headText: t('fainancialView.monthlyAmount'),
    headKey: "price",
  },
  {
    headText: t('fainancialView.ownerRatio'),
    headKey: "owner_ratio",
  },
  {
    headText: t('fainancialView.myRatio'),
    headKey: "my_ratio",
  },
]);
const financials = ref([]);
const loader = ref(false);
// functions
function resetDateEnd() {
  dateEnd.value = "";
}

function getTotalProfits() {
  axios
    .get("/manager/dashboard-home", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      total_profits.value = response.data.data.total_profits;
    });
}
function filterFainancial() {
  loader.value = true;
  if (dateBegin.value && dateEnd.value) {
    axios
      .get(
        `/manager/financials?start_date=${moment(dateBegin.value).format(
          "YYYY-MM-DD"
        )}&end_date=${moment(dateEnd.value).format("YYYY-MM-DD")}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((response) => {
        financials.value = response.data.data.financials;
        loader.value = false;
      });
  } else {
    axios
      .get(
        `/manager/financials`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((response) => {
        financials.value = response.data.data.financials;
        loader.value = false;
      });
  }
}
// lifecycle hooks
onMounted(() => {
  getTotalProfits();
  filterFainancial();

});
</script>
